export const initialOrganizationsState = {
    orgsById: {},
    orgIds: [],
    orgsByBaseUrl: {},
    baseUrls: [],
};
